import React, { useEffect, useRef } from "react";
import { useLanguage } from "../context/LanguageContext";
import "../assets/css/fonts.css";

const Salutations = () => {
  const lineRef = useRef(null);
  const animationRef = useRef(null);
  const { t } = useLanguage();

  const speed = 100;
  const pauseBeforeErase = 1000;
  const pauseBeforeNextLine = 100;

  const typeLine = (text, element, callback) => {
    let i = 0;
    const interval = setInterval(() => {
      if (i < text.length) {
        element.innerText += text.charAt(i);
        i++;
      } else {
        clearInterval(interval);
        callback();
      }
    }, speed);
    return interval;
  };

  const eraseLine = (element, callback) => {
    let text = element.innerText;
    let i = text.length;
    const interval = setInterval(() => {
      if (i > 0) {
        element.innerText = text.substring(0, i - 1);
        text = element.innerText;
        i--;
      } else {
        clearInterval(interval);
        callback();
      }
    }, speed / 2);
    return interval;
  };

  useEffect(() => {
    if (animationRef.current) return;
    animationRef.current = true;

    const element = lineRef.current;
    const lines = t("heroLines");
    let index = 0;

    function next() {
      if (!element) return;
      typeLine(lines[index % lines.length], element, () => {
        setTimeout(() => {
          eraseLine(element, () => {
            index++;
            setTimeout(next, pauseBeforeNextLine);
          });
        }, pauseBeforeErase);
      });
    }

    next();
  }, []);

  return (
    <div className="hero-typewriter">
      <span
        ref={lineRef}
        style={{
          textAlign: "left",
          fontFamily: "Consolaa",
          fontWeight: "bold",
          letterSpacing: "-0.5px",
        }}
      ></span>
      <span className="cursor">|</span>
    </div>
  );
};

export default Salutations;
